import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles(theme => ({
  mainContainer: {
    width: '100%',
    maxWidth: '650px',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  text: {
    color: '#19989B',
    fontWeight: 400,
    fontSize: '25px',
    marginBottom: '20px',
    textAlign: 'center',
    '@media (max-width: 600px)': {
      fontSize: '20px',
      marginBottom: '15px',
    },
  },
  buttons: {
    padding: '10px 12px',
    marginBottom: '0px',
    border: '2px solid #A6A6A6',
    borderRadius: '6px',
    width: '100%',
    height: '96px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  skipText: {
    color: theme.palette.text.primary,
    fontWeight: 300,
    fontSize: '16px',
    marginTop: '5px',
    textDecoration: 'underline',
    cursor: 'pointer',
    textAlign: 'center',
  },
}));

const BriefSourceSelector = ({ text, value, handleSurveyAnswers, id, options = [], allowSkip = true, helperText = '' }) => {
  const classes = useStyles();

  return (
    <Box className={classes.mainContainer}>
      <Typography component="div" variant="h2" className={classes.text}>
        {text}
      </Typography>
      <Box width="100%" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', columnGap: '12px', rowGap: '12px' }}>
        {options.map((option, index) => (
          <Box key={index} style={{ height: '96px' }}>
            <Button
              onClick={() => handleSurveyAnswers(option.value, id)}
              className={classes.buttons}
              style={{
                backgroundColor: option.value === value ? '#19989B' : 'white',
                border: `2px solid ${option.value === value ? '#19989B' : '#A6A6A6'}`,
              }}>
              <p
                style={{
                  margin: 0,
                  color: option.value === value ? 'white' : 'black',
                  textTransform: 'none',
                  fontWeight: 300,
                  fontSize: '18px',
                  lineHeight: 1.2,
                  textAlign: 'center',
                }}>
                {option.text}
              </p>
            </Button>
          </Box>
        ))}
      </Box>
      {helperText ? <Typography component="div" variant="body1" style={{ textAlign: 'center', marginTop: 50, marginBottom: 12 }}>{helperText}</Typography> : null}
      {allowSkip ? (
        <Typography component="div" variant="body2" className={classes.skipText} onClick={() => handleSurveyAnswers('skipped', id)}>
          Skip brief
        </Typography>
      ) : null}
    </Box>
  );
};

export default BriefSourceSelector;
